import http from '@/components/services/http-common';

export const ROUTE = 'departments/office';

class ManagerRoleApi {
  /**
   * Lấy dữ liệu cây cơ cấu tổ chức
   */
  getTree() {
    return http.get(`${ROUTE}/tree`).then(res => {
      if (Array.isArray(res.data)) {
        return res.data;
      } else if (res.data && Array.isArray(res.data.data)) {
        return res.data.data;
      }
      return [];
    });
  }

  /**
   * Lấy danh sách nhân viên
   */
  getEmployees(params) {
    return http.get('employees/v2', { params }).then(res => {
      if (Array.isArray(res.data)) {
        return res.data;
      } else if (res.data && Array.isArray(res.data.data)) {
        return res.data.data;
      }
      return [];
    });
  }

  /**
   * Thay đổi người quản lý
   */
  updateManager(deptCode, manager, level) {
    return http.put(`departments/manager`, null, {
      params: {
        deptCode,
        manager,
        level
      }
    });
  }
}

export default new ManagerRoleApi();
